export class Hotel {
  id:number;
  hotelName: string;
  adresse: string;
  nbrePlace:number;
}
